module.exports = __webpack_public_path__ + "img/svg/icon-players.01c6c0742f0a6111b4935dc60325e384.svg";